<template>
    <div class="app-container">
      <div class="main">
        <div class="main-title">投诉结案</div>
  
       <div class="sub blue">
          <div class="sub-title">项目信息</div>
          <div class="text item">
            {{ "投诉编号" }}&nbsp;:&nbsp;{{logIdList.complaintCode}}
          </div>
          <div class="text item">
            {{ "项目名称" }}&nbsp;:&nbsp;{{logIdList.projectName  }}
          </div>
          <div class="text item">
            {{ "总包单位" }}&nbsp;:&nbsp;{{ logIdList.generalContractor }}
          </div>
          <div class="text item">
            {{ "分包单位" }}&nbsp;:&nbsp;{{logIdList.subcontractor }}
          </div>
          <div class="text item">
            {{ "负责人联系方式" }}&nbsp;:&nbsp;{{logIdList.phone }}
          </div>
        </div>
  
        <div class="sub gray">
          <div class="sub-title">投诉内容</div>
          <div class="text item">
            {{ "投诉人" }}&nbsp;:&nbsp;{{logIdList.userId  }}
          </div>
          <div class="text item">
            {{ "岗位" }}&nbsp;:&nbsp;{{ logIdList.position }}
          </div>
          <div class="text item">
            {{ "欠薪金额" }}&nbsp;:&nbsp;{{logIdList.arrearsAmount  }} <span v-if="logIdList.arrearsAmount">元</span>
          </div>
          <div class="text item">
            {{ "欠薪时间" }}&nbsp;:&nbsp;{{logIdList.wageArrearsStart }} 至 {{ logIdList.wageArrearsEnd }}
          </div>
          <div class="text item">
            {{ "备注" }}&nbsp;:&nbsp;{{logIdList.remarks }}
          </div>
          <div class="sub-title second">附件</div>
          <template v-if="logIdList.processAttachments && logIdList.processAttachments.length > 0">
            <div class="fujian">
              <div class="boxs" v-for="(value, index) in logIdList.processAttachments" :key="index">
                <template v-if="value.fileType === 1">
                  <img :src="value.fileUrl" alt="">
                  <span>{{ value.fileName }}</span>
                </template>
                <template v-else-if="value.fileType === 2">
                  <img src="https://baojiuye-test.oss-cn-shanghai.aliyuncs.com/static/img/pdf.png" alt="">
                  <span>{{ value.fileName }}</span>
                </template>
                <template v-else-if="value.fileType === 3">
                  <img src="https://baojiuye-test.oss-cn-shanghai.aliyuncs.com/static/img/word.png"  alt="">
                  <span>{{ value.fileName }}</span>
                </template>
                <template v-else>
                  <img src="https://baojiuye-test.oss-cn-shanghai.aliyuncs.com/static/img/default-file.png"  alt="">
                  <span>{{ value.fileName }}</span>
                </template>
              </div>
            </div>
          </template>
          <div v-else>无</div>
        </div>
  
        <!-- <div class="sub gray">
          <div class="sub-title">处理结果</div>
          <div style="color:#666;font-size: 14px">处理结果说明：已联系分包单位核实情况，确认欠薪事实，已支付欠薪12,500元</div>
          <div class="sub-title second">处理附件</div>
          <div style="display:flex;justify-content: left;">
            <div class="fujian">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M9 12h.01M15 12h.01M9 18h.01M15 18h.01"></path>
              </svg>
            </div>
            <div class="fujian">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M9 12h.01M15 12h.01M9 18h.01M15 18h.01"></path>
              </svg>
            </div>
          </div>
  
        </div> -->
  
        <div class="sub white">
          <div class="sub-title">结案处置</div>
          <el-form 
            ref="formRef" 
            :model="form" 
            :rules="rules" 
            :label-position="'top'" 
            :label-width="'auto'"
          >
            <el-form-item label="处置意见" prop="desc">
              <el-input 
                type="textarea" 
                v-model="form.desc" 
                placeholder="请填写处置意见...."
                :rows="4"
              ></el-input>
            </el-form-item>
            <el-form-item label="审核结果" prop="region" v-if="0">
              <el-radio-group v-model="form.region">
                <el-radio :label="1">通过结案</el-radio>
                <el-radio :label="2">驳回处理</el-radio>
                <el-radio :label="3">无效投诉</el-radio>
              </el-radio-group>
            </el-form-item>
  
            <el-form-item>
              <el-button size="large" @click="handleCancel">取消</el-button>
              <el-button type="success" @click="onSubmit">确认结案</el-button>
            </el-form-item>
          </el-form>
  
  
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { getComplaintDetail, getEnd } from "@/api/unpaidWages/complaint";

  export default {
    name: 'ComplaintAuditing',
    data() {
      return {
        id: "0",
        logIdList: {},
        form: {
          desc: '',
          region: 1
        },
        rules: {
          desc: [
            { required: true, message: '请填写审核意见', trigger: 'blur' }
          ],
          region: [
            { required: true, message: '请选择审核结果', trigger: 'change' }
          ]
        }
      }
    },
    mounted() {
      // 从store中获取id
      this.id = this.$store.state.attachment.currentId;
      // 使用这个id进行后续操作
      console.log('投诉ID:', this.id);
      this.getDisposalInfo();
    },
    methods: {
      // 获取投诉信息
      async getDisposalInfo() {
        try {
          const res = await getComplaintDetail({id: this.id});
          console.log(res.data);
          this.logIdList = res.data;
        } catch (error) {
          console.error('获取投诉信息失败:', error);
          this.$message.error('获取投诉信息失败');
        }
      },
      
      // 提交结案
      async onSubmit() {
        if (!this.$refs.formRef) return;
        
        try {
          // 验证表单
          try {
            await this.$refs.formRef.validate();
          } catch (error) {
            return console.log(error);
          }
          
          // 打印表单数据，用于调试
          console.log('表单数据:', {
            complaintId: this.id,
            caseExplain: this.form.desc,
            caseStatus: this.form.region
          });
          
          // 构建提交数据
          const submitData = {
            id: this.id,
            caseExplain: this.form.desc,
            caseStatus: this.form.region
          };
          
          // 发送请求
          const res = await getEnd(submitData);
          console.log('服务器响应:', res);
          
          if (res.data) {
            this.$message.success('提交成功');
            // 可以在这里添加跳转逻辑
            this.$router.push({
              path: '/unpaidWages/complaint/exception',
            });
          } else {
            this.$message.error((res.data && res.data.message) || '提交失败');
          }
        } catch (error) {
          console.error('提交失败:', error);
          this.$message.error('表单验证失败或提交失败');
        }
      },
      
      // 取消按钮处理
      handleCancel() {
        // 重置表单
        if (this.$refs.formRef) {
          this.$refs.formRef.resetFields();
        }
        // 可以在这里添加返回上一页或其他逻辑
        this.$router.push({
          path: '/unpaidWages/complaint/exception',
        });
      }
    }
  }
  </script>
  
  
  <style scoped>
  
  .log {
    clear: both;
    overflow: hidden;
  }

  .log span {
    height: 1px;
    line-height: 0;
    font-size: 0;
    padding: 0;
    width: 1px;
    border: 5px solid blue;
    border-radius: 5px;
    display: inline-block;
    margin: 0 10px 0 0;
  }

  .log-title {
    line-height: 30px;
    font-weight: bold;
  }

  .log-cont {
    padding: 0 0 0 20px;
  }


  .app-container {
    background: #f7f8f9;
  }

  .el-select .el-input {
    width: 100%;
  }

  .main {
    border: #fff 1px solid;
    border-radius: 10px;
    background: #fff;
    padding: 10px;
  }

  .main-title {
    font-size: 18px;
    padding: 10px;
    font-weight: bold;
  }

  .sub {
    border: #fff 1px solid;
    border-radius: 10px;
    background: #fff;
    padding: 20px 20px 14px;
    margin: 10px;
    font-size: 16px;
    font-weight: normal;
    line-height: 28px;
  }

  .sub.blue {
    border-color: #EDF4FDFF;
    background: #EDF4FDFF;
  }

  .sub.gray {
    border-color: #F7F8F9FF;
    background: #F7F8F9FF;
  }

  .sub.white {
    border-color: #ccc;
  }

  .sub-title {
    font-size: 18px;
    font-weight: bold;
    padding: 0 0 10px 0;
  }

  .sub-title.second {
    padding-top: 20px;
  }

  .fujian {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
  }
  
  .fujian .boxs {
    border: 2px dotted #aaa;
    border-radius: 5px;
    overflow: hidden;
    width: 100px;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    margin-right: 15px;
    margin-bottom: 15px;
  }

  .fujian .boxs:hover {
    border-color: #409EFF;
    transform: translateY(-2px);
  }

  .fujian .boxs img {
    max-width: 40px;
    max-height: 40px;
    margin-bottom: 5px;
  }

  .fujian .boxs span {
    font-size: 12px;
    color: #666;
    text-align: center;
    padding: 0 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 90px;
    border: none;
    height: auto;
    line-height: normal;
    margin: 0;
  }

  .fujian svg {
    height: 20px;
    width: 20px;
  }

  </style>
